export default __webpack_public_path__ + "static/media/tema.428ddbb8.png";